import React, { useState, useEffect, useRef } from 'react';
import './Register.css';
import logoImg from '../../assets/logo.png';

const experienceOptions = [
  "Not Applicable",
  "Less than 1 Years",
  "Between 1 to 5 Years",
  "More than 5 Years"
];

const experienceShortLabels = [
  "N/A",
  "< 1 yr",
  "1 - 5 yrs",
  "> 5 yrs"
];

const countryCodesList = [
  { code: '+1', country: 'United States / Canada' },
  { code: '+7', country: 'Russia / Kazakhstan' },
  { code: '+20', country: 'Egypt' },
  { code: '+27', country: 'South Africa' },
  { code: '+30', country: 'Greece' },
  { code: '+31', country: 'Netherlands' },
  { code: '+32', country: 'Belgium' },
  { code: '+33', country: 'France' },
  { code: '+34', country: 'Spain' },
  { code: '+36', country: 'Hungary' },
  { code: '+39', country: 'Italy' },
  { code: '+40', country: 'Romania' },
  { code: '+41', country: 'Switzerland' },
  { code: '+43', country: 'Austria' },
  { code: '+44', country: 'United Kingdom' },
  { code: '+45', country: 'Denmark' },
  { code: '+46', country: 'Sweden' },
  { code: '+47', country: 'Norway' },
  { code: '+48', country: 'Poland' },
  { code: '+49', country: 'Germany' },
  { code: '+51', country: 'Peru' },
  { code: '+52', country: 'Mexico' },
  { code: '+53', country: 'Cuba' },
  { code: '+54', country: 'Argentina' },
  { code: '+55', country: 'Brazil' },
  { code: '+56', country: 'Chile' },
  { code: '+57', country: 'Colombia' },
  { code: '+58', country: 'Venezuela' },
  { code: '+60', country: 'Malaysia' },
  { code: '+61', country: 'Australia' },
  { code: '+62', country: 'Indonesia' },
  { code: '+63', country: 'Philippines' },
  { code: '+64', country: 'New Zealand' },
  { code: '+65', country: 'Singapore' },
  { code: '+66', country: 'Thailand' },
  { code: '+81', country: 'Japan' },
  { code: '+82', country: 'South Korea' },
  { code: '+84', country: 'Vietnam' },
  { code: '+86', country: 'China' },
  { code: '+90', country: 'Turkey' },
  { code: '+91', country: 'India' },
  { code: '+92', country: 'Pakistan' },
  { code: '+93', country: 'Afghanistan' },
  { code: '+94', country: 'Sri Lanka' },
  { code: '+95', country: 'Myanmar' },
  { code: '+98', country: 'Iran' },
  { code: '+212', country: 'Morocco' },
  { code: '+213', country: 'Algeria' },
  { code: '+216', country: 'Tunisia' },
  { code: '+218', country: 'Libya' },
  { code: '+220', country: 'Gambia' },
  { code: '+221', country: 'Senegal' },
  { code: '+234', country: 'Nigeria' },
  { code: '+254', country: 'Kenya' },
  { code: '+255', country: 'Tanzania' },
  { code: '+256', country: 'Uganda' },
  { code: '+260', country: 'Zambia' },
  { code: '+263', country: 'Zimbabwe' },
  { code: '+264', country: 'Namibia' },
  { code: '+351', country: 'Portugal' },
  { code: '+353', country: 'Ireland' },
  { code: '+354', country: 'Iceland' },
  { code: '+355', country: 'Albania' },
  { code: '+358', country: 'Finland' },
  { code: '+359', country: 'Bulgaria' },
  { code: '+370', country: 'Lithuania' },
  { code: '+371', country: 'Latvia' },
  { code: '+372', country: 'Estonia' },
  { code: '+375', country: 'Belarus' },
  { code: '+380', country: 'Ukraine' },
  { code: '+381', country: 'Serbia' },
  { code: '+385', country: 'Croatia' },
  { code: '+386', country: 'Slovenia' },
  { code: '+420', country: 'Czech Republic' },
  { code: '+421', country: 'Slovakia' },
  { code: '+502', country: 'Guatemala' },
  { code: '+503', country: 'El Salvador' },
  { code: '+504', country: 'Honduras' },
  { code: '+505', country: 'Nicaragua' },
  { code: '+506', country: 'Costa Rica' },
  { code: '+507', country: 'Panama' },
  { code: '+591', country: 'Bolivia' },
  { code: '+593', country: 'Ecuador' },
  { code: '+595', country: 'Paraguay' },
  { code: '+598', country: 'Uruguay' },
  { code: '+673', country: 'Brunei' },
  { code: '+674', country: 'Nauru' },
  { code: '+675', country: 'Papua New Guinea' },
  { code: '+679', country: 'Fiji' },
  { code: '+852', country: 'Hong Kong' },
  { code: '+853', country: 'Macau' },
  { code: '+855', country: 'Cambodia' },
  { code: '+856', country: 'Laos' },
  { code: '+880', country: 'Bangladesh' },
  { code: '+886', country: 'Taiwan' },
  { code: '+960', country: 'Maldives' },
  { code: '+961', country: 'Lebanon' },
  { code: '+962', country: 'Jordan' },
  { code: '+963', country: 'Syria' },
  { code: '+964', country: 'Iraq' },
  { code: '+965', country: 'Kuwait' },
  { code: '+966', country: 'Saudi Arabia' },
  { code: '+967', country: 'Yemen' },
  { code: '+968', country: 'Oman' },
  { code: '+971', country: 'United Arab Emirates' },
  { code: '+972', country: 'Israel' },
  { code: '+973', country: 'Bahrain' },
  { code: '+974', country: 'Qatar' },
  { code: '+975', country: 'Bhutan' },
  { code: '+976', country: 'Mongolia' },
  { code: '+977', country: 'Nepal' },
  { code: '+992', country: 'Tajikistan' },
  { code: '+993', country: 'Turkmenistan' },
  { code: '+994', country: 'Azerbaijan' },
  { code: '+995', country: 'Georgia' },
  { code: '+996', country: 'Kyrgyzstan' },
  { code: '+998', country: 'Uzbekistan' }
].sort((a, b) => a.country.localeCompare(b.country));

const Register = ({ onSwitchView }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const formRef = useRef(null);
  const isFirstStepMount = useRef(true);
  const isTransitioningStepRef = useRef(false);

  const [formData, setFormData] = useState({
    fullName: '',
    username: '',
    organisationId: '',
    newOrganisationName: '',
    sectorType: '',
    projectCode: '',
    gender: '',
    email: '',
    password: '',
    confirmPassword: '',
    countryCode: '+60',
    contact: '',
    position: '',
    itBackground: '',
    experienceYears: 'Not Applicable',
    feeAcknowledgement: false,
    privacyConsent: false,
    supervisorName: '',
    supervisorEmail: '',
    // Completion page fields
    hearAboutUs: '',
    hearOtherText: '',
    privacyGlobal: false,
    privacyThirdParty: false,
    privacyTransferOutside: false,
    privacyBreachNotify: false,
    privacyPhotography: false,
    privacyAge18: false,
    privacyTermsBound: false,
    privacyNoticeAgree: false,
    privacyProcessConsent: false,
    consentPrivacyForm: false,
    consentEmailComms: false
  });

  const [statusMessage, setStatusMessage] = useState({ type: '', text: '' });
  const [phoneError, setPhoneError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Secure card expand/retract state (retracted on mobile by default to focus on form, expanded on desktop)
  const [isSecureCardExpanded, setIsSecureCardExpanded] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth > 992;
    }
    return false;
  });

  const toggleSecureCard = () => {
    setIsSecureCardExpanded(prev => !prev);
  };

  // Organisations state
  const [organisations, setOrganisations] = useState([]);
  const [orgSearchTerm, setOrgSearchTerm] = useState('');
  const [isOrgDropdownOpen, setIsOrgDropdownOpen] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const orgDropdownRef = useRef(null);
  const [isCreatingNewOrg, setIsCreatingNewOrg] = useState(false);

  // Country Code Dropdown state
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
  const [countrySearchTerm, setCountrySearchTerm] = useState('');
  const countryDropdownRef = useRef(null);

  // Username validation state
  const [usernameError, setUsernameError] = useState('');
  const [isCheckingUsername, setIsCheckingUsername] = useState(false);
  const usernameTimerRef = useRef(null);

  // Email domain auto-matching state
  const [emailDomainMatch, setEmailDomainMatch] = useState(null); // { domain, orgs, sector }
  const [isCheckingDomain, setIsCheckingDomain] = useState(false);
  const emailDomainTimerRef = useRef(null);

  // Project Code validation state
  const [projectCodeStatus, setProjectCodeStatus] = useState(null);
  const [isCheckingProjectCode, setIsCheckingProjectCode] = useState(false);
  const projectCodeTimerRef = useRef(null);

  // Real-time project code validation against UserTag
  useEffect(() => {
    if (projectCodeTimerRef.current) clearTimeout(projectCodeTimerRef.current);
    const code = (formData.projectCode || '').trim();
    if (!code) {
      setProjectCodeStatus(null);
      setIsCheckingProjectCode(false);
      return;
    }

    setIsCheckingProjectCode(true);
    projectCodeTimerRef.current = setTimeout(async () => {
      try {
        const res = await fetch('/api/special-project/validate', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ projectCode: code })
        });
        const data = await res.json();
        if (res.ok && data.valid) {
          setProjectCodeStatus({
            valid: true,
            tag: data.tag,
            eligibleCourses: data.eligibleCourses || [],
            message: `✓ Verified: ${data.tag.tagName} (${(data.eligibleCourses || []).length} exclusive course(s) unlocked)`
          });
        } else {
          setProjectCodeStatus({
            valid: false,
            message: data.message || 'Invalid or expired project code.'
          });
        }
      } catch (err) {
        setProjectCodeStatus(null);
      } finally {
        setIsCheckingProjectCode(false);
      }
    }, 400);
  }, [formData.projectCode]);

  // Username real-time validation check
  useEffect(() => {
    if (usernameTimerRef.current) {
      clearTimeout(usernameTimerRef.current);
    }

    const username = formData.username.trim();
    if (!username) {
      setUsernameError('');
      setIsCheckingUsername(false);
      return;
    }

    // 1. Check if first character is a letter
    if (!/^[a-zA-Z]/.test(username)) {
      if (username.startsWith('_')) {
        setUsernameError('Username must start with a letter.');
      } else {
        setUsernameError('Username must start with a letter and special characters can only be _.');
      }
      setIsCheckingUsername(false);
      return;
    }

    // 2. Check if it contains only letters, numbers, and underscores
    if (!/^[a-zA-Z0-9_]+$/.test(username)) {
      setUsernameError('Username must start with a letter and special characters can only be _.');
      setIsCheckingUsername(false);
      return;
    }

    // 3. Check length
    if (username.length < 3 || username.length > 20) {
      setUsernameError('Username must be between 3 and 20 characters.');
      setIsCheckingUsername(false);
      return;
    }

    setIsCheckingUsername(true);
    setUsernameError('');

    usernameTimerRef.current = setTimeout(async () => {
      try {
        const response = await fetch(`/api/check-username/${encodeURIComponent(username)}`);
        const data = await response.json();
        if (data.status === 'success') {
          if (data.exists) {
            setUsernameError('Username is already taken.');
          } else {
            setUsernameError(''); // Available!
          }
        }
      } catch (error) {
        console.error('Error checking username:', error);
      } finally {
        setIsCheckingUsername(false);
      }
    }, 500);

    return () => {
      if (usernameTimerRef.current) {
        clearTimeout(usernameTimerRef.current);
      }
    };
  }, [formData.username]);

  // Auto-compute privacyConsent: true only when ALL privacy & consent boxes are checked
  useEffect(() => {
    const allChecked =
      formData.privacyGlobal &&
      formData.privacyThirdParty &&
      formData.privacyTransferOutside &&
      formData.privacyBreachNotify &&
      formData.privacyPhotography &&
      formData.privacyAge18 &&
      formData.privacyTermsBound &&
      formData.privacyNoticeAgree &&
      formData.privacyProcessConsent &&
      formData.consentPrivacyForm &&
      formData.consentEmailComms;
    setFormData(prev => ({ ...prev, privacyConsent: allChecked }));
  }, [
    formData.privacyGlobal, formData.privacyThirdParty, formData.privacyTransferOutside,
    formData.privacyBreachNotify, formData.privacyPhotography, formData.privacyAge18,
    formData.privacyTermsBound, formData.privacyNoticeAgree, formData.privacyProcessConsent,
    formData.consentPrivacyForm, formData.consentEmailComms
  ]);

  // Fetch organisations when sector changes
  useEffect(() => {
    if (['Government', 'Private', 'Student'].includes(formData.sectorType)) {
      fetchOrganisations(formData.sectorType);
    }
  }, [formData.sectorType]);

  // Email domain auto-matching: debounced lookup when email changes
  useEffect(() => {
    // Clear any pending timer
    if (emailDomainTimerRef.current) {
      clearTimeout(emailDomainTimerRef.current);
    }

    const email = formData.email.trim();
    const atIndex = email.indexOf('@');

    // Only proceed if there's a valid-looking email with domain
    if (atIndex === -1 || atIndex === email.length - 1) {
      setEmailDomainMatch(null);
      setIsCheckingDomain(false);
      return;
    }

    const domain = email.substring(atIndex + 1).toLowerCase();

    // Basic domain validation - needs at least one dot
    if (!domain.includes('.') || domain.endsWith('.') || domain.startsWith('.')) {
      setEmailDomainMatch(null);
      setIsCheckingDomain(false);
      return;
    }

    setIsCheckingDomain(true);

    // Debounce the API call by 500ms
    emailDomainTimerRef.current = setTimeout(async () => {
      try {
        const response = await fetch(`/api/organisations-by-domain/${encodeURIComponent(domain)}`);
        const data = await response.json();

        if (data.status === 'success' && data.data.length > 0) {
          const matchedOrgs = data.data;
          const matchedSector = data.sector;

          setEmailDomainMatch({
            domain,
            orgs: matchedOrgs,
            sector: matchedSector
          });

          // Auto-set the sector if not already set or different
          if (formData.sectorType !== matchedSector) {
            setFormData(prev => ({
              ...prev,
              sectorType: matchedSector,
              organisationId: '',
              newOrganisationName: ''
            }));
            setIsCreatingNewOrg(false);
            setOrgSearchTerm('');
          }

          // If exactly one org matches, auto-select it
          if (matchedOrgs.length === 1) {
            const org = matchedOrgs[0];
            setSelectedOrg(org);
            setFormData(prev => ({
              ...prev,
              sectorType: matchedSector,
              organisationId: org.OrganisationID.toString(),
              newOrganisationName: ''
            }));
            setIsCreatingNewOrg(false);
            setOrgSearchTerm('');
            setIsOrgDropdownOpen(false);
          } else {
            // Multiple matches — clear selection so user can pick
            setSelectedOrg(null);
            setFormData(prev => ({
              ...prev,
              organisationId: '',
              newOrganisationName: ''
            }));
            setIsOrgDropdownOpen(true);
          }
        } else {
          setEmailDomainMatch(null);
        }
      } catch (error) {
        console.error('Error checking email domain:', error);
        setEmailDomainMatch(null);
      } finally {
        setIsCheckingDomain(false);
      }
    }, 500);

    return () => {
      if (emailDomainTimerRef.current) {
        clearTimeout(emailDomainTimerRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.email]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (orgDropdownRef.current && !orgDropdownRef.current.contains(event.target)) {
        setIsOrgDropdownOpen(false);
      }
      if (countryDropdownRef.current && !countryDropdownRef.current.contains(event.target)) {
        setIsCountryDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const fetchOrganisations = async (sector) => {
    try {
      const response = await fetch(`/api/organisations/${sector.toLowerCase()}`);
      const data = await response.json();
      if (data.status === 'success') {
        setOrganisations(data.data);
      }
    } catch (error) {
      console.error('Error fetching organisations:', error);
    }
  };

  // Filter organisations — if email domain matched, prioritize those orgs
  const baseOrgs = emailDomainMatch && emailDomainMatch.orgs.length > 0 ? emailDomainMatch.orgs : organisations;

  let exactOrgs = [];
  let fuzzyOrgs = [];

  if (formData.sectorType === 'Government' && orgSearchTerm) {
    const term = orgSearchTerm.toLowerCase();
    baseOrgs.forEach(org => {
      const name = org.OrganisationName.toLowerCase();
      if (name.includes(term)) {
        exactOrgs.push(org);
      } else {
        let termIdx = 0;
        let nameIdx = 0;
        while (termIdx < term.length && nameIdx < name.length) {
          if (term[termIdx] === name[nameIdx]) {
            termIdx++;
          }
          nameIdx++;
        }
        if (termIdx === term.length) {
          fuzzyOrgs.push(org);
        }
      }
    });
  } else {
    exactOrgs = baseOrgs.filter(org =>
      org.OrganisationName.toLowerCase().includes(orgSearchTerm.toLowerCase())
    );
  }

  const isGovernmentSearch = formData.sectorType === 'Government' && orgSearchTerm;

  const filteredCountries = countryCodesList.filter(c =>
    c.code.includes(countrySearchTerm) || c.country.toLowerCase().includes(countrySearchTerm.toLowerCase())
  );

  const passwordCriteria = {
    length: formData.password.length >= 8 && formData.password.length <= 20,
    uppercase: /[A-Z]/.test(formData.password),
    specialChar: /[!@#$%^&*(),.?":{}|<>\-_+=[\]\\/'`]/.test(formData.password)
  };

  const isPasswordValid = Object.values(passwordCriteria).every(Boolean);
  const passwordStrength = Object.values(passwordCriteria).filter(Boolean).length;

  const isPhoneValid = () => {
    const digits = formData.contact.replace(/\D/g, '');
    if (!digits) return false;
    return digits.length >= 8 && digits.length <= 15;
  };

  // Compute phone digit info for the progress bar
  const getPhoneDigitInfo = () => {
    const digits = formData.contact.replace(/\D/g, '');
    const currentDigits = digits.length;
    const requiredDigits = 8; // minimum digits for international numbers
    const isValid = currentDigits >= requiredDigits && currentDigits <= 15;
    const progress = Math.min(currentDigits / requiredDigits, 1);
    return { currentDigits, requiredDigits, isValid, progress };
  };
  const phoneDigitInfo = getPhoneDigitInfo();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'contact') {
      // Validate phone number immediately as the user types
      const digits = value.replace(/\D/g, '');
      if (digits.length === 0) {
        setPhoneError('');
      } else {
        let valid = digits.length >= 8 && digits.length <= 15;
        if (!valid) {
          setPhoneError('Invalid phone number length. Minimum 8 digits required.');
        } else {
          setPhoneError('');
        }
      }
    }
    const uppercaseFields = ['fullName', 'position', 'newOrganisationName', 'projectCode', 'supervisorName'];
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : (uppercaseFields.includes(name) ? value.toUpperCase() : value)
    }));
  };

  const handleSectorChange = (e) => {
    const newSector = e.target.value;
    setFormData(prevState => ({
      ...prevState,
      sectorType: newSector,
      organisationId: '',
      newOrganisationName: ''
    }));
    setSelectedOrg(null);
    setOrgSearchTerm('');
    setIsOrgDropdownOpen(false);
    setIsCreatingNewOrg(false);
  };

  const handleOrgSelect = (org) => {
    if (org === 'CREATE_NEW') {
      setIsCreatingNewOrg(true);
      setSelectedOrg(null);
      setFormData(prevState => ({
        ...prevState,
        organisationId: ''
      }));
    } else {
      setSelectedOrg(org);
      setIsCreatingNewOrg(false);
      setFormData(prevState => ({
        ...prevState,
        organisationId: org.OrganisationID.toString(),
        newOrganisationName: ''
      }));
    }
    setOrgSearchTerm('');
    setIsOrgDropdownOpen(false);
  };

  const scrollToTop = () => {
    const performScroll = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      const rightPanel = document.querySelector('.right-panel');
      if (rightPanel) {
        rightPanel.scrollTo({ top: 0, behavior: 'smooth' });
        rightPanel.scrollTop = 0;
      }
      const splitContainer = document.querySelector('.split-layout-container');
      if (splitContainer) {
        splitContainer.scrollTo({ top: 0, behavior: 'smooth' });
        splitContainer.scrollTop = 0;
      }
    };

    performScroll();
    setTimeout(performScroll, 50);
  };

  // When first entering the registration page, always return to the very top
  useEffect(() => {
    const resetToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      const splitContainer = document.querySelector('.split-layout-container');
      if (splitContainer) splitContainer.scrollTop = 0;
      const rightPanel = document.querySelector('.right-panel');
      if (rightPanel) rightPanel.scrollTop = 0;
    };
    resetToTop();
    const timer = setTimeout(resetToTop, 50);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isFirstStepMount.current) {
      isFirstStepMount.current = false;
      return;
    }
    scrollToTop();
  }, [currentStep]);

  const handleNextStep = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (formRef.current) {
      if (formRef.current.reportValidity()) {
        if (currentStep === 1) {
          if (!formData.username.trim()) {
            setStatusMessage({ type: 'error', text: 'Username is required.' });
            return;
          }
          if (usernameError) {
            setStatusMessage({ type: 'error', text: usernameError });
            return;
          }
          if (!isPasswordValid) {
            setStatusMessage({ type: 'error', text: 'Please ensure your password meets all requirements.' });
            return;
          }
          if (formData.password !== formData.confirmPassword) {
            setStatusMessage({ type: 'error', text: 'Passwords do not match.' });
            return;
          }
          if (!isPhoneValid()) {
            setPhoneError('Invalid phone number length. Minimum 8 digits required.');
            return;
          }
        }
        setPhoneError('');
        setStatusMessage({ type: '', text: '' });
        isTransitioningStepRef.current = true;
        setTimeout(() => {
          isTransitioningStepRef.current = false;
        }, 500);
        setCurrentStep(prev => Math.min(prev + 1, 2));
        scrollToTop();
      }
    } else {
      if (currentStep === 1) {
        if (!formData.username.trim()) {
          setStatusMessage({ type: 'error', text: 'Username is required.' });
          return;
        }
        if (usernameError) {
          setStatusMessage({ type: 'error', text: usernameError });
          return;
        }
        if (!isPasswordValid) {
          setStatusMessage({ type: 'error', text: 'Please ensure your password meets all requirements.' });
          return;
        }
        if (formData.password !== formData.confirmPassword) {
          setStatusMessage({ type: 'error', text: 'Passwords do not match.' });
          return;
        }
        if (!isPhoneValid()) {
          setPhoneError('Invalid phone number format. 011 numbers should have 11 digits (or 12 with 60), others 10 digits.');
          return;
        }
      }

      setPhoneError('');
      setStatusMessage({ type: '', text: '' });
      isTransitioningStepRef.current = true;
      setTimeout(() => {
        isTransitioningStepRef.current = false;
      }, 500);
      setCurrentStep(prev => Math.min(prev + 1, 2));
      scrollToTop();
    }
  };

  const handlePrevStep = () => {
    setStatusMessage({ type: '', text: '' });
    setCurrentStep(prev => Math.max(prev - 1, 1));
    scrollToTop();
  };

  const handleStepClick = (step) => {
    setStatusMessage({ type: '', text: '' });
    setCurrentStep(step);
    scrollToTop();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prevent submission if still transitioning steps or not on the final step
    if (currentStep < 2 || isTransitioningStepRef.current) {
      return;
    }

    // Final check for all required data could go here, 
    // but the last step's reportValidity is handled by HTML5 validation on submit.
    if (!formData.username.trim()) {
      setCurrentStep(1);
      setStatusMessage({ type: 'error', text: 'Username is required.' });
      return;
    }

    if (usernameError) {
      setCurrentStep(1);
      setStatusMessage({ type: 'error', text: usernameError });
      return;
    }

    if (!isPasswordValid) {
      setCurrentStep(1);
      setStatusMessage({ type: 'error', text: 'Please ensure your password meets all requirements.' });
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setCurrentStep(1);
      setStatusMessage({ type: 'error', text: 'Passwords do not match.' });
      return;
    }

    if (!isPhoneValid()) {
      setCurrentStep(1);
      setPhoneError('Invalid phone number length. Minimum 8 digits required.');
      return;
    }

    if (!formData.feeAcknowledgement) {
      setCurrentStep(2);
      setStatusMessage({ type: 'error', text: 'Please complete the program fee acknowledgement.' });
      return;
    }

    // Strict validation for Government sector supervisor details
    const isGovernmentRegistration = formData.sectorType === 'Government';
    if (isGovernmentRegistration) {
      if (!formData.supervisorName || !formData.supervisorName.trim()) {
        setCurrentStep(2);
        setStatusMessage({ type: 'error', text: 'Supervisor Name is strictly required for Government civil service registrations.' });
        return;
      }
      if (!formData.supervisorEmail || !formData.supervisorEmail.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.supervisorEmail.trim())) {
        setCurrentStep(2);
        setStatusMessage({ type: 'error', text: 'A valid Supervisor Email is strictly required for Government civil service registrations.' });
        return;
      }
    }

    // Check completion page validations
    if (!formData.hearAboutUs) {
      setStatusMessage({ type: 'error', text: 'Please select an option for how you heard about us.' });
      return;
    }

    // privacyConsent is auto-computed: true only when ALL privacy + consent checkboxes are ticked
    if (!formData.privacyConsent) {
      setStatusMessage({ type: 'error', text: 'Please agree to all privacy terms and conditions to submit your registration.' });
      return;
    }

    setIsSubmitting(true);
    setStatusMessage({ type: '', text: '' });

    try {
      const payload = { ...formData };
      payload.contact = `${formData.countryCode} ${formData.contact}`;
      if (isGovernmentRegistration) {
        payload.accountStatus = 'Pending Verification';
      }

      const response = await fetch('/api/learners', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        const isPending = isGovernmentRegistration || data.isPendingVerification || data.accountStatus === 'Pending Verification';
        const pendingDetails = {
          organisationName: data.organisationName || formData.newOrganisationName || selectedOrg?.OrganisationName || 'Government Ministry / Agency',
          supervisorName: formData.supervisorName,
          supervisorEmail: formData.supervisorEmail,
          referenceId: data.referenceId || `GOV-${data.learnerId || 'REF'}`,
          email: formData.email,
          fullName: formData.fullName,
          slaDeadline: data.slaDeadline
        };

        setStatusMessage({
          type: 'success',
          text: isPending 
            ? 'Civil service registration submitted! Redirecting to 48-hour administrative verification status...'
            : (data.message || 'Registration submitted successfully! A confirmation email has been sent to your email address.')
        });

        // Clear the form after success
        setFormData({
          fullName: '',
          username: '',
          organisationId: '',
          newOrganisationName: '',
          sectorType: '',
          projectCode: '',
          gender: '',
          email: '',
          password: '',
          confirmPassword: '',
          countryCode: '+60',
          contact: '',
          position: '',
          itBackground: '',
          experienceYears: 'Not Applicable',
          feeAcknowledgement: false,
          privacyConsent: false,
          supervisorName: '',
          supervisorEmail: '',
          hearAboutUs: '',
          hearOtherText: '',
          privacyGlobal: false,
          privacyThirdParty: false,
          privacyTransferOutside: false,
          privacyBreachNotify: false,
          privacyPhotography: false,
          privacyAge18: false,
          privacyTermsBound: false,
          privacyNoticeAgree: false,
          privacyProcessConsent: false,
          consentPrivacyForm: false,
          consentEmailComms: false
        });
        setSelectedOrg(null);
        setOrgSearchTerm('');
        setIsCreatingNewOrg(false);
        setEmailDomainMatch(null);
        setCurrentStep(1); // Go back to first step after success

        // Route government learners to /registration-pending view, others to login
        setTimeout(() => {
          if (isPending) {
            if (onSwitchView) onSwitchView('registration-pending', pendingDetails);
          } else {
            if (onSwitchView) onSwitchView('login');
          }
        }, 1500);
      } else {
        setStatusMessage({ type: 'error', text: data.message || 'Registration failed.' });

        if (data.message === 'Organisation name already exists.') {
          // Fetch the latest list of organisations
          if (['Government', 'Private', 'Student'].includes(formData.sectorType)) {
            fetchOrganisations(formData.sectorType);
          }
          // Navigate to step 1 so they can fix it
          setCurrentStep(1);
          // Clear the new organisation name fields
          setFormData(prev => ({
            ...prev,
            newOrganisationName: '',
            organisationId: ''
          }));
          setIsCreatingNewOrg(false);
          setOrgSearchTerm('');
        }
      }
    } catch (error) {
      console.error('Submission error:', error);
      setStatusMessage({ type: 'error', text: 'Failed to connect to the server. Is it running?' });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Render the conditional field based on sector type
  const renderSectorField = () => {
    if (['Government', 'Private', 'Student'].includes(formData.sectorType)) {
      let label = '';
      let placeholder = '';

      if (formData.sectorType === 'Government') {
        label = 'Government Organisation';
        placeholder = 'SEARCH FOR GOVERNMENT ORGANISATION...';
      } else if (formData.sectorType === 'Private') {
        label = 'Company Name';
        placeholder = 'SEARCH FOR COMPANY...';
      } else if (formData.sectorType === 'Student') {
        label = 'University / College Name';
        placeholder = 'SEARCH FOR UNIVERSITY / COLLEGE...';
      }

      return (
        <div className="form-group sector-conditional-field">
          <label>{label} <span className="required">*</span></label>
          <div className="gov-dropdown-wrapper" ref={orgDropdownRef}>
            <div className="input-with-icon">
              <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                {formData.sectorType === 'Government' ? (
                  <><path d="M3 21h18"></path><path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16"></path><path d="M9 21v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4"></path><path d="M9 7h6"></path><path d="M9 11h6"></path></>
                ) : formData.sectorType === 'Private' ? (
                  <><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></>
                ) : (
                  <><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></>
                )}
              </svg>
              <input
                type="text"
                className="gov-search-input"
                placeholder={placeholder}
                title={selectedOrg ? selectedOrg.OrganisationName : orgSearchTerm}
                value={isOrgDropdownOpen ? orgSearchTerm : (selectedOrg ? selectedOrg.OrganisationName.toUpperCase() : (isCreatingNewOrg ? 'CREATING NEW...' : orgSearchTerm))}
                onChange={(e) => {
                  setOrgSearchTerm(e.target.value.toUpperCase());
                  setIsOrgDropdownOpen(true);
                  if (selectedOrg || isCreatingNewOrg) {
                    setSelectedOrg(null);
                    setIsCreatingNewOrg(false);
                    setFormData(prev => ({ ...prev, organisationId: '', newOrganisationName: '' }));
                  }
                }}
                onFocus={() => setIsOrgDropdownOpen(true)}
                required={!selectedOrg && !isCreatingNewOrg}
              />
            </div>
            {isOrgDropdownOpen && (
              <div className="gov-dropdown-list">
                {isGovernmentSearch ? (
                  <>
                    {exactOrgs.length > 0 && (
                      <>
                        <div className="gov-dropdown-header" style={{ padding: '8px 12px', fontSize: '0.85em', fontWeight: 'bold', color: '#666', backgroundColor: '#f9f9f9' }}>Matched</div>
                        {exactOrgs.map(org => (
                          <div
                            key={org.OrganisationID}
                            className={`gov-dropdown-item ${selectedOrg?.OrganisationID === org.OrganisationID ? 'selected' : ''}`}
                            onClick={() => handleOrgSelect(org)}
                          >
                            {org.OrganisationName}
                          </div>
                        ))}
                      </>
                    )}
                    {fuzzyOrgs.length > 0 && (
                      <>
                        <div className="gov-dropdown-header" style={{ padding: '8px 12px', fontSize: '0.85em', fontWeight: 'bold', color: '#666', backgroundColor: '#f9f9f9' }}>Others</div>
                        {fuzzyOrgs.map(org => (
                          <div
                            key={org.OrganisationID}
                            className={`gov-dropdown-item ${selectedOrg?.OrganisationID === org.OrganisationID ? 'selected' : ''}`}
                            onClick={() => handleOrgSelect(org)}
                          >
                            {org.OrganisationName}
                          </div>
                        ))}
                      </>
                    )}
                    {exactOrgs.length === 0 && fuzzyOrgs.length === 0 && (
                      <div className="gov-dropdown-item no-results" style={{ cursor: 'default' }}>No organisations found</div>
                    )}
                    {exactOrgs.length === 0 && fuzzyOrgs.length === 0 && (
                      <div
                        className="gov-dropdown-item create-new-item"
                        onClick={() => handleOrgSelect('CREATE_NEW')}
                        style={{ fontWeight: 'bold', color: '#3b28cc', borderTop: '1px solid #e2e8f0' }}
                      >
                        CREATE NEW?
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {exactOrgs.length > 0 ? (
                      exactOrgs.map(org => (
                        <div
                          key={org.OrganisationID}
                          className={`gov-dropdown-item ${selectedOrg?.OrganisationID === org.OrganisationID ? 'selected' : ''}`}
                          onClick={() => handleOrgSelect(org)}
                        >
                          {org.OrganisationName}
                        </div>
                      ))
                    ) : (
                      <div className="gov-dropdown-item no-results" style={{ cursor: 'default' }}>No organisations found</div>
                    )}
                    {exactOrgs.length === 0 && (
                      <div
                        className="gov-dropdown-item create-new-item"
                        onClick={() => handleOrgSelect('CREATE_NEW')}
                        style={{ fontWeight: 'bold', color: '#3b28cc', borderTop: '1px solid #e2e8f0' }}
                      >
                        CREATE NEW?
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>

          {isCreatingNewOrg && (
            <div className="input-with-icon" style={{ marginTop: '10px' }}>
              <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
              <input
                type="text"
                name="newOrganisationName"
                value={formData.newOrganisationName}
                onChange={handleChange}
                required
                placeholder={`ENTER NEW ${label.toUpperCase()}`}
              />
            </div>
          )}

          {formData.sectorType === 'Government' && (
            <div className="ack-supervisor-section" style={{ marginTop: '25px', marginBottom: '0' }}>
              <h4 style={{ marginBottom: '12px', color: '#1e293b', fontSize: '16px', fontWeight: '600' }}>Supervisor Details</h4>
              <div className="form-row">
                <div className="form-group half">
                  <label htmlFor="supervisorName" style={{ paddingTop: 0 }}>Supervisor Name</label>
                  <div className="input-with-icon">
                    <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    <input type="text" id="supervisorName" name="supervisorName" value={formData.supervisorName} onChange={handleChange} placeholder="E.G. JANE DOE" />
                  </div>
                </div>
                <div className="form-group half">
                  <label htmlFor="supervisorEmail" style={{ paddingTop: 0 }}>Supervisor Email</label>
                  <div className="input-with-icon">
                    <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                    <input type="email" id="supervisorEmail" name="supervisorEmail" value={formData.supervisorEmail} onChange={handleChange} placeholder="jane@example.com" />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }

    return null;
  };

  const usernameCriteria = {
    startsWithLetter: formData.username.length > 0 && /^[a-zA-Z]/.test(formData.username),
    charLength: formData.username.length >= 3 && formData.username.length <= 20,
    validChars: formData.username.length > 0 && /^[a-zA-Z0-9_]+$/.test(formData.username),
    noSpaces: formData.username.length > 0 && !/\s/.test(formData.username)
  };

  const isUsernameBorderRed = formData.username.length > 0 && (
    usernameError ||
    !usernameCriteria.startsWithLetter ||
    !usernameCriteria.charLength ||
    !usernameCriteria.validChars ||
    !usernameCriteria.noSpaces
  );

  const isUsernameBorderGreen = formData.username.length > 0 && (
    !usernameError &&
    usernameCriteria.startsWithLetter &&
    usernameCriteria.charLength &&
    usernameCriteria.validChars &&
    usernameCriteria.noSpaces &&
    !isCheckingUsername
  );

  return (
    <div className="split-layout-container">
      {/* Left Panel */}
      <div className="left-panel">
        <div className="left-panel-top">
          <img src={logoImg} alt="BlackBerry" className="brand-logo" />
        </div>

        <div className="left-panel-middle">
          <div className="registration-steps-container">
            <h4 className="steps-title">REGISTRATION STEPS</h4>
            <div className="steps-list">
              <div className={`step-item ${currentStep === 1 ? 'current' : (currentStep > 1 ? 'active' : '')}`} onClick={() => handleStepClick(1)} style={{ cursor: 'pointer' }}>
                <div className="step-number">1</div>
                <div className="step-content">
                  <h5>Registration Page</h5>
                  <p>Enter your details</p>
                </div>
                <div className="step-line"></div>
              </div>
              <div className={`step-item ${currentStep === 2 ? 'current' : ''}`} onClick={() => handleStepClick(2)} style={{ cursor: 'pointer' }}>
                <div className="step-number">2</div>
                <div className="step-content">
                  <h5>Acknowledgement & Completion</h5>
                  <p>Program fee acknowledgement and Registration summary</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="left-panel-bottom">
          <div className={`secure-registration-card ${isSecureCardExpanded ? 'expanded' : 'retracted'}`}>
            <div 
              className="secure-card-header" 
              onClick={toggleSecureCard}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  toggleSecureCard();
                }
              }}
              role="button"
              tabIndex={0}
              aria-expanded={isSecureCardExpanded}
              aria-label={isSecureCardExpanded ? "Retract security information" : "Expand security information"}
            >
              <div className="secure-header-left">
                <div className="secure-icon-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="shield-icon-mini">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                    <polyline points="9 12 11 14 15 10"></polyline>
                  </svg>
                </div>
                <div className="secure-header-text">
                  <h3>Your Information is Safe</h3>
                  <span className="secure-status-tag">256-bit SSL Encrypted</span>
                </div>
              </div>
              <div className="secure-header-action">
                <span className="secure-toggle-hint">{isSecureCardExpanded ? 'Hide' : 'Details'}</span>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="18" 
                  height="18" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2.5" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  className={`secure-card-chevron ${isSecureCardExpanded ? 'open' : ''}`}
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </div>

            <div className="secure-card-body">
              <div className="secure-icon-wrapper desktop-only-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="shield-icon">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  <polyline points="9 12 11 14 15 10"></polyline>
                </svg>
              </div>
              <p className="secure-card-description">
                We use secure encryption to protect your personal data and ensure privacy.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel */}
      <div className="right-panel">
        <div className="form-container">

          <div className="form-header-wrapper">
            <div className="form-title-section">
              <div className="form-title-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect><path d="M9 14h6"></path><path d="M9 18h6"></path><path d="M9 10h.01"></path></svg>
              </div>
              <div>
                <h2>Student Program Registration</h2>
                <p>Please complete the form below to register for the selected program.</p>
              </div>
            </div>

            {statusMessage.text && (
              <div className={`toast-message ${statusMessage.type}`}>
                <div className="toast-icon">
                  {statusMessage.type === 'success' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                  )}
                </div>
                <div className="toast-content">
                  <span className="toast-title">{statusMessage.type === 'success' ? 'Success!' : 'Error'}</span>
                  <span className="toast-desc">{statusMessage.text}</span>
                </div>
                <button type="button" className="toast-close" onClick={() => setStatusMessage({ type: '', text: '' })}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
              </div>
            )}
          </div>

          <form onSubmit={handleSubmit} className="registration-form" ref={formRef}>

            {/* STEP 1: Registration Details */}
            {currentStep === 1 && (
              <div className="form-step-content fade-in">
                <div className="form-row">
                  <div className="form-group full">
                    <label htmlFor="fullName">Full Name (as per IC) <span className="required">*</span></label>
                    <div className="input-with-icon">
                      <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                      <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required placeholder="E.G. JOHN DOE" />
                    </div>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group half">
                    <label htmlFor="username">Username <span className="required">*</span></label>
                    <div className="input-with-icon" style={{ position: 'relative' }}>
                      <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                      <input
                        type="text"
                        id="username"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        placeholder="E.G. JOHNDOE123"
                        style={{
                          borderColor: isUsernameBorderRed ? '#ef4444' : (isUsernameBorderGreen ? '#10b981' : undefined)
                        }}
                      />
                      {isCheckingUsername && (
                        <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px', color: '#94a3b8' }}>⏳</span>
                      )}
                    </div>
                    {/* Live Username Checklist */}
                    {formData.username.length > 0 && (
                      <div className="password-strength-checker" style={{ marginTop: '0.75rem' }}>
                        <ul className="strength-criteria-list">
                          <li className={usernameCriteria.charLength ? 'met' : 'unmet'}>
                            <span className="bullet" style={{ marginRight: '8px' }}></span> At least 3-20 characters
                          </li>
                          <li className={usernameCriteria.startsWithLetter ? 'met' : 'unmet'}>
                            <span className="bullet" style={{ marginRight: '8px' }}></span> Starts with a letter
                          </li>
                          <li className={usernameCriteria.validChars ? 'met' : 'unmet'}>
                            <span className="bullet" style={{ marginRight: '8px' }}></span> Contains only letters, numbers and underscores _
                          </li>
                          {usernameCriteria.charLength && usernameCriteria.startsWithLetter && usernameCriteria.validChars && !isCheckingUsername && (
                            <li className={usernameError ? 'unmet' : 'met'}>
                              <span className="bullet" style={{ marginRight: '8px' }}></span> {usernameError ? usernameError : 'Username is available'}
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                  </div>

                  <div className="form-group half">
                    <label htmlFor="email">Business Email Address <span className="required">*</span></label>
                    <div className="input-with-icon">
                      <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required placeholder="john@example.com" />
                      {isCheckingDomain && (
                        <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px', color: '#94a3b8' }}>⏳</span>
                      )}
                    </div>
                    {emailDomainMatch && (
                      <div className="email-domain-match-banner" style={{
                        marginTop: '8px',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        background: 'linear-gradient(135deg, #ecfdf5, #f0fdf4)',
                        border: '1px solid #86efac',
                        fontSize: '12.5px',
                        color: '#166534',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        animation: 'fadeIn 0.3s ease-out'
                      }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                        <span>
                          {emailDomainMatch.orgs.length === 1
                            ? <>Organisation auto-detected: <strong>{emailDomainMatch.orgs[0].OrganisationName}</strong></>
                            : <>Domain <strong>@{emailDomainMatch.domain}</strong> matched {emailDomainMatch.orgs.length} organisations — please select below</>
                          }
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group half" style={{ gap: '0.5rem' }}>
                    <label htmlFor="password">Password <span className="required">*</span></label>
                    <div className="password-input-wrapper" style={{ position: 'relative', width: '100%' }}>
                      <div className="input-with-icon" style={{ width: '100%' }}>
                        <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                        </svg>
                        <input
                          type={showPassword ? "text" : "password"}
                          id="password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          required
                          placeholder="Create a password"
                          style={{ paddingRight: '2.5rem' }}
                        />
                      </div>
                      <div className="eye-icon" onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#94a3b8' }}>
                        {showPassword ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                        )}
                      </div>
                    </div>
                    {/* Password Strength Checker */}
                    {formData.password.length > 0 && (
                      <div className="password-strength-checker">
                        <div className="strength-bar-container">
                          <div
                            className={`strength-bar-fill strength-${passwordStrength}`}
                            style={{ width: `${(passwordStrength / 3) * 100}%` }}
                          ></div>
                        </div>
                        <ul className="strength-criteria-list">
                          <li className={passwordCriteria.length ? 'met' : 'unmet'}>
                            <span className="bullet"></span> At least 8-20 characters
                          </li>
                          <li className={passwordCriteria.uppercase ? 'met' : 'unmet'}>
                            <span className="bullet"></span> Contains 1 uppercase letter
                          </li>
                          <li className={passwordCriteria.specialChar ? 'met' : 'unmet'}>
                            <span className="bullet"></span> Contains 1 special character
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>

                  <div className="form-group half" style={{ gap: '0.5rem' }}>
                    <label htmlFor="confirmPassword">Confirm Password <span className="required">*</span></label>
                    <div className="password-input-wrapper" style={{ position: 'relative', width: '100%' }}>
                      <div className="input-with-icon" style={{ width: '100%' }}>
                        <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                        </svg>
                        <input
                          type={showPassword ? "text" : "password"}
                          id="confirmPassword"
                          name="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                          required
                          placeholder="Confirm your password"
                          style={{ paddingRight: '2.5rem' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group half">
                    <label htmlFor="contact">Phone Number <span className="required">*</span></label>
                    <div className="phone-input-group" style={{ display: 'flex', gap: '8px' }}>
                      <div className="gov-dropdown-wrapper" ref={countryDropdownRef} style={{ width: '35%', marginBottom: 0, position: 'relative' }}>
                        <div className="input-with-icon select-wrapper" style={{ marginBottom: 0 }}>
                          <input
                            type="text"
                            className="gov-search-input"
                            style={{ paddingLeft: '12px', cursor: 'text' }}
                            placeholder="Code"
                            value={isCountryDropdownOpen ? countrySearchTerm : `${formData.countryCode} (${countryCodesList.find(c => c.code === formData.countryCode)?.country || ''})`}
                            onChange={(e) => {
                              setCountrySearchTerm(e.target.value);
                              setIsCountryDropdownOpen(true);
                            }}
                            onFocus={() => {
                              setCountrySearchTerm('');
                              setIsCountryDropdownOpen(true);
                            }}
                            required
                          />
                        </div>
                        {isCountryDropdownOpen && (
                          <div className="gov-dropdown-list" style={{ position: 'absolute', top: '100%', left: 0, width: '250%', zIndex: 10, maxHeight: '200px', overflowY: 'auto' }}>
                            {filteredCountries.length > 0 ? (
                              filteredCountries.map(c => (
                                <div
                                  key={c.code + c.country}
                                  className={`gov-dropdown-item ${formData.countryCode === c.code ? 'selected' : ''}`}
                                  onClick={() => {
                                    setFormData(prev => ({ ...prev, countryCode: c.code }));
                                    setIsCountryDropdownOpen(false);
                                  }}
                                  style={{ padding: '8px 12px' }}
                                >
                                  {c.code} ({c.country})
                                </div>
                              ))
                            ) : (
                              <div className="gov-dropdown-item no-results" style={{ cursor: 'default' }}>No country found</div>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="input-with-icon" style={{ width: '65%', marginBottom: 0 }}>
                        <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                        <input type="tel" id="contact" name="contact" value={formData.contact} onChange={handleChange} required placeholder="" style={{ borderColor: phoneError ? '#ef4444' : (phoneDigitInfo.isValid ? '#10b981' : undefined) }} />
                      </div>
                    </div>
                    {/* Phone Digit Progress Bar */}
                    {phoneDigitInfo.currentDigits > 0 && (
                      <div className="phone-digit-checker" style={{ marginTop: '8px' }}>
                        <div className="phone-bar-container">
                          <div
                            className={`phone-bar-fill ${phoneDigitInfo.isValid ? 'phone-valid' : 'phone-invalid'}`}
                            style={{ width: `${phoneDigitInfo.progress * 100}%` }}
                          ></div>
                        </div>
                        <div className={`phone-digit-label ${phoneDigitInfo.isValid ? 'phone-valid-text' : 'phone-invalid-text'}`}>
                          <span className="phone-digit-bullet"></span>
                          {phoneDigitInfo.isValid
                            ? `✓ Valid phone number length`
                            : `Minimum ${phoneDigitInfo.requiredDigits} digits required`
                          }
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="form-group half">
                    <label htmlFor="gender">Gender <span className="required">*</span></label>
                    <div className="input-with-icon select-wrapper">
                      <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                      <select id="gender" name="gender" value={formData.gender} onChange={handleChange} required>
                        <option value="" disabled>Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Prefer not to say">Prefer not to say</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group full">
                    <label htmlFor="sectorType">Which sector are you from? <span className="required">*</span></label>
                    <div className="input-with-icon select-wrapper">
                      <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path></svg>
                      <select id="sectorType" name="sectorType" value={formData.sectorType} onChange={handleSectorChange} required>
                        <option value="" disabled>Select Sector</option>
                        <option value="Government">Government</option>
                        <option value="Private">Private</option>
                        <option value="Student">Student</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Conditional fields based on sector selection */}
                {formData.sectorType && renderSectorField()}

                <div className="form-row">
                  <div className="form-group full">
                    <label htmlFor="projectCode">Project Code (Provided by BlackBerry) (If Applicable)</label>
                    <div className="input-with-icon">
                      <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                      <input
                        type="text"
                        id="projectCode"
                        name="projectCode"
                        value={formData.projectCode}
                        onChange={handleChange}
                        placeholder="E.G. SP-2025-00123"
                        data-testid="register-project-code-input"
                      />
                      {isCheckingProjectCode && (
                        <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px', color: '#94a3b8' }}>⏳</span>
                      )}
                    </div>
                    {projectCodeStatus && (
                      <div
                        data-testid="register-project-code-feedback"
                        style={{
                          marginTop: '6px',
                          padding: '8px 12px',
                          borderRadius: '8px',
                          fontSize: '12.5px',
                          border: `1px solid ${projectCodeStatus.valid ? '#86efac' : '#fca5a5'}`,
                          backgroundColor: projectCodeStatus.valid ? '#f0fdf4' : '#fef2f2',
                          color: projectCodeStatus.valid ? '#166534' : '#991b1b',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '3px'
                        }}
                      >
                        <div style={{ fontWeight: 600 }}>{projectCodeStatus.message}</div>
                        {projectCodeStatus.valid && projectCodeStatus.eligibleCourses?.length > 0 && (
                          <div style={{ fontSize: '11.5px', color: '#15803d' }}>
                            Unlocked Courses: {projectCodeStatus.eligibleCourses.map(c => c.CourseName).join(', ')}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group half">
                    <label htmlFor="position">Position <span className="required">*</span></label>
                    <div className="input-with-icon">
                      <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
                      <input type="text" id="position" name="position" value={formData.position} onChange={handleChange} required placeholder="E.G. SOFTWARE ENGINEER" />
                    </div>
                  </div>

                  <div className="form-group half">
                    <label htmlFor="itBackground">IT Background <span className="required">*</span></label>
                    <div className="input-with-icon select-wrapper">
                      <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>
                      <select id="itBackground" name="itBackground" value={formData.itBackground} onChange={handleChange} required>
                        <option value="" disabled>Select an option</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-group full experience-group">
                  <div className="slider-header-row">
                    <label htmlFor="experienceYears" className="slider-title-label">Experience (Years)</label>
                    <span className="slider-value-badge">
                      {formData.experienceYears || experienceOptions[0]}
                    </span>
                  </div>
                  <div className="slider-container">
                    <input
                      type="range"
                      id="experienceYears"
                      name="experienceYears"
                      min="0"
                      max="3"
                      step="1"
                      value={Math.max(0, experienceOptions.indexOf(formData.experienceYears))}
                      onChange={(e) => {
                        setFormData(prev => ({
                          ...prev,
                          experienceYears: experienceOptions[e.target.value]
                        }));
                      }}
                      className="experience-slider"
                      list="experience-ticks"
                    />
                    <datalist id="experience-ticks">
                      <option value="0"></option>
                      <option value="1"></option>
                      <option value="2"></option>
                      <option value="3"></option>
                    </datalist>
                    <div className="slider-labels-container">
                      {experienceOptions.map((option, index) => (
                        <span
                          key={index}
                          className={`slider-label slider-label-${index} ${formData.experienceYears === option ? 'active' : ''}`}
                          onClick={() => setFormData(prev => ({ ...prev, experienceYears: option }))}
                        >
                          <span className="desktop-label">{option}</span>
                          <span className="mobile-label">{experienceShortLabels[index]}</span>
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* STEP 2: Acknowledgement */}
            {currentStep === 2 && (
              <div className="form-step-content fade-in" style={{ minHeight: '300px' }}>
                {/* Section Title */}
                <div className="ack-section-title">
                  <h3>Acknowledgement & Completion</h3>
                  <div className="ack-title-underline"></div>
                </div>

                {/* Info Banner */}
                <div className="ack-info-banner">
                  <div className="ack-info-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    </svg>
                  </div>
                  <div className="ack-info-text">
                    <p>Please be informed that government officer in civil services may be eligible to receive complimentary training.</p>
                    <p>Eligibility requirements apply. You will be notified via email if you do not meet the criteria for the complimentary training.</p>
                  </div>
                </div>



                {/* Fee Acknowledgement Checkbox */}
                <div className="ack-fee-section">
                  <label className="ack-fee-label">Program Fee Acknowledgement <span className="required">*</span></label>
                  <label className="ack-checkbox-wrapper">
                    <input
                      type="checkbox"
                      name="feeAcknowledgement"
                      checked={formData.feeAcknowledgement}
                      onChange={handleChange}
                      className="ack-checkbox"
                      required
                    />
                    <span className="ack-checkbox-custom"></span>
                    <span className="ack-checkbox-text">Yes, I understand that some of the training programs are available for a fee.</span>
                  </label>
                </div>


                {/* Info Banner */}
                <div className="completion-info-banner" style={{ marginTop: '50px' }}>
                  <div className="completion-info-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    </svg>
                  </div>
                  <span>Please read and agree to all terms before submitting your registration.</span>
                </div>

                {/* How did you hear about us? */}
                <div className="completion-section">
                  <h4 className="completion-section-label">How did you hear about us? <span className="required">*</span></h4>
                  <div className="input-with-icon select-wrapper" style={{ marginBottom: formData.hearAboutUs === 'Other' ? '15px' : '0' }}>
                    <svg className="input-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
                    <select
                      name="hearAboutUs"
                      value={formData.hearAboutUs}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>Select an option</option>
                      <option value="Official Website">Official Website</option>
                      <option value="Social Media">Social Media</option>
                      <option value="Email Announcement or Newsletter">Email Announcement or Newsletter</option>
                      <option value="Recommendation from a Colleague or Friend">Recommendation from a Colleague or Friend</option>
                      <option value="Referral from an Organization">Referral from an Organization</option>
                      <option value="Advertisement">Advertisement</option>
                      <option value="INTAN">INTAN</option>
                      <option value="Other">Other (please specify)</option>
                    </select>
                  </div>
                  {formData.hearAboutUs === 'Other' && (
                    <div className="hear-other-input">
                      <input
                        type="text"
                        name="hearOtherText"
                        value={formData.hearOtherText}
                        onChange={handleChange}
                        placeholder="Please specify..."
                        required
                      />
                    </div>
                  )}
                </div>

                {/* Malaysia Privacy Supplement */}
                <div className="completion-section">
                  <h4 className="completion-section-label">Malaysia Privacy Supplement <span className="required">*</span></h4>
                  <div className="privacy-supplement-list">
                    <label className="privacy-item">
                      <input type="checkbox" name="privacyGlobal" checked={formData.privacyGlobal} onChange={handleChange} />
                      <span className="privacy-checkbox-custom"></span>
                      <span>I have read and understood BlackBerry's Global Privacy Policy and this Malaysia Supplement and I consent to the collection use and sharing of my personal data as described in these documents</span>
                    </label>
                    <label className="privacy-item">
                      <input type="checkbox" name="privacyThirdParty" checked={formData.privacyThirdParty} onChange={handleChange} />
                      <span className="privacy-checkbox-custom"></span>
                      <span>I understand that my personal data may be shared with third-party course providers as necessary to deliver the courses I have registered for</span>
                    </label>
                    <label className="privacy-item">
                      <input type="checkbox" name="privacyTransferOutside" checked={formData.privacyTransferOutside} onChange={handleChange} />
                      <span className="privacy-checkbox-custom"></span>
                      <span>I consent to my personal data being transferred outside Malaysia in accordance with PDPA safeguards</span>
                    </label>
                    <label className="privacy-item">
                      <input type="checkbox" name="privacyBreachNotify" checked={formData.privacyBreachNotify} onChange={handleChange} />
                      <span className="privacy-checkbox-custom"></span>
                      <span>I acknowledge that I will be notified in the event of a personal data breach that is likely to result in significant harm to me</span>
                    </label>
                    <label className="privacy-item">
                      <input type="checkbox" name="privacyPhotography" checked={formData.privacyPhotography} onChange={handleChange} />
                      <span className="privacy-checkbox-custom"></span>
                      <span>I grant BlackBerry CCoE its parent companies subsidiaries and/or affiliates permission to take and use photographs and/or recordings that may include me during course activities for promotional purposes</span>
                    </label>
                    <label className="privacy-item">
                      <input type="checkbox" name="privacyAge18" checked={formData.privacyAge18} onChange={handleChange} />
                      <span className="privacy-checkbox-custom"></span>
                      <span>I confirm that I am 18 years of age or older and have the right to contract in my own name</span>
                    </label>
                    <label className="privacy-item">
                      <input type="checkbox" name="privacyTermsBound" checked={formData.privacyTermsBound} onChange={handleChange} />
                      <span className="privacy-checkbox-custom"></span>
                      <span>I have read understood and agree to be bound by the Course Registration Terms & Conditions</span>
                    </label>
                    <label className="privacy-item">
                      <input type="checkbox" name="privacyNoticeAgree" checked={formData.privacyNoticeAgree} onChange={handleChange} />
                      <span className="privacy-checkbox-custom"></span>
                      <span>By checking this box you acknowledge that you have read understood and agree to this Privacy Notice and the statements above</span>
                    </label>
                    <label className="privacy-item">
                      <input type="checkbox" name="privacyProcessConsent" checked={formData.privacyProcessConsent} onChange={handleChange} />
                      <span className="privacy-checkbox-custom"></span>
                      <span>By ticking this box I agree to let you process my registration (Registration Form Version 2025.1)</span>
                    </label>
                  </div>
                  <div className="tick-all-wrapper" style={{ marginTop: '15px' }}>
                    <label className="privacy-item tick-all-label" style={{ fontWeight: '600', color: '#3b28cc' }}>
                      <input
                        type="checkbox"
                        checked={
                          formData.privacyGlobal &&
                          formData.privacyThirdParty &&
                          formData.privacyTransferOutside &&
                          formData.privacyBreachNotify &&
                          formData.privacyPhotography &&
                          formData.privacyAge18 &&
                          formData.privacyTermsBound &&
                          formData.privacyNoticeAgree &&
                          formData.privacyProcessConsent
                        }
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setFormData(prev => ({
                            ...prev,
                            privacyGlobal: isChecked,
                            privacyThirdParty: isChecked,
                            privacyTransferOutside: isChecked,
                            privacyBreachNotify: isChecked,
                            privacyPhotography: isChecked,
                            privacyAge18: isChecked,
                            privacyTermsBound: isChecked,
                            privacyNoticeAgree: isChecked,
                            privacyProcessConsent: isChecked
                          }));
                        }}
                      />
                      <span className="privacy-checkbox-custom"></span>
                      <span>Tick for all</span>
                    </label>
                  </div>
                </div>

                {/* Review notice */}
                <div className="completion-review-notice">
                  <p>Kindly go through the details below and ensure all boxes are checked for us to process your registration.</p>
                </div>

                {/* Final Consent Section */}
                <div className="completion-consent-box">
                  <label className="consent-item">
                    <input type="checkbox" name="consentPrivacyForm" checked={formData.consentPrivacyForm} onChange={handleChange} />
                    <span className="consent-checkbox-custom"></span>
                    <span>By submitting this form, I acknowledge that I have read and agreed to the <a href="#privacy-supplement">Malaysia Privacy Supplement and Consent Form</a> and the CCoE <a href="#terms">Course Registration Terms & Conditions</a> document.</span>
                  </label>
                  <label className="consent-item">
                    <input type="checkbox" name="consentEmailComms" checked={formData.consentEmailComms} onChange={handleChange} />
                    <span className="consent-checkbox-custom"></span>
                    <span>By submitting this form, I agree to receive email communications about products, services and events from BlackBerry Malaysia Centre of Excellence SDN BHD and its affiliates. I understand that I can unsubscribe at any time. I confirm that I have read and agree to the BlackBerry <a href="#privacy-policy">Privacy Policy</a>.</span>
                  </label>
                  {(!formData.consentPrivacyForm || !formData.consentEmailComms) && (
                    <p className="consent-warning">Please accept the terms & conditions to submit this form.</p>
                  )}
                </div>

              </div>
            )}

            {/* Form Navigation */}
            <div className="form-navigation">
              {currentStep > 1 && (
                <button type="button" className="nav-btn prev-btn" onClick={handlePrevStep}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                  Back
                </button>
              )}

              {currentStep < 2 ? (
                <button
                  key="btn-next-step"
                  type="button"
                  className="submit-btn next-btn"
                  onClick={handleNextStep}
                >
                  Next Step
                </button>
              ) : (
                <button
                  key="btn-submit-registration"
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitting}
                  onClick={(e) => {
                    if (isTransitioningStepRef.current) {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
                  {isSubmitting ? 'Submitting...' : 'Submit Registration'}
                </button>
              )}
            </div>

            <div className="form-footer">
              Already registered? <a href="#login" onClick={(e) => { e.preventDefault(); if (onSwitchView) onSwitchView('login'); }}>Login here</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
